var exports = {};
exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};
export default exports;